import { isValidCron } from 'cron-validator'
import { z } from 'zod'

const OUTPUT_FORMAT_OPTIONS = ['timestamp', 'iso8601']

const schedulerSchema = z
  .object({
    groupConfigId: z.string().trim().min(1, 'Group config is required'),
    elementId: z.string().trim().min(1, 'Element is required'),
    name: z.string().trim(),
    startDate: z.string().trim().min(1, 'Start date is required'),
    endDate: z.string().trim(),
    outputFormatTime: z.enum(OUTPUT_FORMAT_OPTIONS),
    duration: z.string().trim(),
    isDefault: z.boolean(),
    isFrozen: z.boolean(),
  })
  .superRefine((value, ctx) => {
    if (!isValidCron(value.startDate)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Start date must be a valid cron expression',
        path: ['startDate'],
      })
    }

    const hasEndDate = value.endDate.length > 0
    const hasDuration = value.duration.length > 0

    if (!hasEndDate && !hasDuration) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Provide end date or duration',
        path: ['endDate'],
      })
    }

    if (hasEndDate && !isValidCron(value.endDate)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'End date must be a valid cron expression',
        path: ['endDate'],
      })
    }

    if (hasDuration) {
      const duration = Number(value.duration)
      if (!Number.isFinite(duration) || duration < 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Duration must be a non-negative number',
          path: ['duration'],
        })
      }
    }
  })

export function validateSchedulerForm(values) {
  const result = schedulerSchema.safeParse(values)

  if (!result.success) {
    return {
      success: false,
      error: result.error.issues[0]?.message || 'Invalid scheduler form values',
    }
  }

  return {
    success: true,
    data: result.data,
  }
}
